export type ImagePlacement =
  | 'tour_banner'
  | 'tour_gallery'
  | 'tour_itinerary'
  | 'hotel_cover'
  | 'hotel_gallery'
  | 'blog_cover'
  | 'blog_gallery'
  | 'slider'
  | 'page_block'
  | 'avatar'
  | 'icon'
  | 'og'
  | 'general'

/** Recommended pixel size shown next to upload fields (must match API presets). */
export const IMAGE_PLACEMENT_SIZE: Record<ImagePlacement, string> = {
  tour_banner: '1600×900 px',
  tour_gallery: '1200×1200 px',
  tour_itinerary: '1000×750 px',
  hotel_cover: '1600×900 px',
  hotel_gallery: '1200×900 px',
  blog_cover: '1400×788 px',
  blog_gallery: '1200×800 px',
  slider: '1920×800 px',
  page_block: '1400×900 px',
  avatar: '400×400 px',
  icon: '256×256 px',
  og: '1200×630 px',
  general: 'max 1600 px (largeur)',
}

export function recommendedSizeFor(placement?: ImagePlacement | string): string {
  const key = (placement || 'general') as ImagePlacement
  return IMAGE_PLACEMENT_SIZE[key] || IMAGE_PLACEMENT_SIZE.general
}
